module.exports = __webpack_public_path__ + "img/contact-background-banner.4bad8e39.png";